import Vue from 'vue'
import store from '../store/index'
import VueRouter from 'vue-router'

import error from '../views/404'
import error403 from '../views/403'

import Login from '../views/login'
import Register from '../views/register'
import Recovery from '../views/recovery'

import Home from '../views/Home'
import Dashboard from '../views/Dashboard'

import Profile from '../views/Profile'

import Users from '../views/Users'
import Roles from '../views/Roles/Roles'
import Role from '../views/Roles/Role'
import RolesInProject from '../views/Roles/RolesInProject'
import AssignedRoles from '../views/Roles/AssignedRoles'

import Things from '../views/Things/Things'
import ThingsThing from '../views/Things/ThingsThing'
import Virtual from '../views/Things/Virtual'
import ThingsInProject from '../views/Things/ThingsInProject'
import ThingsInProjectItem from '../views/Things/ThingsInProjectItem'

import Projects from '../views/Projects/Projects'
import Project from '../views/Projects/Project'
import ProjectItem from '../views/Projects/ProjectItem'
import ProjectEdit from '../views/Projects/ProjectEdit'

import Journal from '../views/Journal/Journal'
import JournalItem from '../views/Journal/JournalItem'
import JournalCreate from '../views/Journal/JournalCreate'

Vue.use(VueRouter);

const routes = [
  {
    path: '/404',
    name: '404',
    component: error,
    meta: {
      title: 'OmniIoTh | Страница не найдена'
    }
  },
  {
    path: '/403',
    name: '403',
    component: error403,
    meta: {
      title: 'OmniIoTh | Доступ запрещен'
    }
  },
  {
    path: '*',
    redirect: '/404',
    meta: {
      title: 'OmniIoTh | Страница не найдена'
    }
  },
	{
		path: '/components',
		name: 'home',
		component: Home,
    meta: {
		  requireAuth: true,
      title: 'OmniIoTh | Компоненты'
    }
	},
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: 'OmniIoTh | Регистрация'
    }
  },
  {
    path: '/login',
    component: Login,
    meta: {
      title: 'OmniIoTh | Войти'
    }
  },
  {
    path: '/recovery',
    component: Recovery,
    meta: {
      title: 'OmniIoTh | Восстановление пароля'
    }
  },
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Главная'
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Профиль'
    }
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Пользователи'
    },
    // children: {
    //   path: '/user/:id',
    //   component: Users,
    // }
  },
  {
    path: '/users/:id',
    name: 'usersGroup',
    component: Users,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Пользователи'
    },
  },
  {
    path: '/roles',
    name: 'roles',
    component: Roles,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Группы ролей'
    },
    children: [
      {
        path: 'project/:id',
        name: 'rolesInProject',
        component: RolesInProject,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Роли'
        }
      },
      {
        path: 'project/:id/project-item/:item',
        name: 'rolesInProjectItem',
        component: RolesInProject,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Роли'
        }
      }
    ]
  },
  {
    path: '/roles/role/:id',
    name: 'role',
    component: Role,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Роль'
    }
  },
  {
    path: '/assigned-roles',
    name: 'AssignedRoles',
    component: AssignedRoles,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Присвоенные роли'
    }
  },
  {
    path: '/things',
    name: 'things',
    component: Things,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Вещи'
    },
    children: [
      {
        path: 'project/:id',
        name: 'ThingsInProject',
        component: ThingsInProject,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Вещи'
        }
      },
      {
        path: 'project/:id/project-item/:item',
        name: 'ThingsInProjectItem',
        component: ThingsInProjectItem,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Вещи'
        }
      },
      {
        path: 'thing/:id',
        name: 'thing',
        component: ThingsThing,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Вещь'
        }
      },
      /*{
        path: 'group/:id',
        name: 'groupThingA',
        component: ThingsGroup,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Вещь'
        },
      },
      {
        path: 'group/:id/settings',
        name: 'groupSettings',
        component: ThingGroupSingle,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Вещь'
      }
      },*/
      {
        path: 'multithing/:id',
        name: 'virtualThingList',
        component: Virtual,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Вещь'
        }
      }

    ]
  },
  {
    path: '/projects',
    name: 'projects',
    component: Projects,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Проекты'
    }
  },
  {
    path: '/project-edit/:id',
    name: 'project-edit',
    component: ProjectEdit,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Редактирование какого-то проекта'
    }
  },
  {
    path: '/project-edit/:id/project-item/:item',
    name: 'projectItem.project-edit-item',
    component: ProjectEdit,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Редактирование проекта'
    }
  },
  {
    path: '/project/:id',
    name: 'project',
    component: Project,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Проект'
    },
    children: [
      {
        path: 'project-item/:item',
        name: 'projectItem',
        component: ProjectItem,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Проект'
        }
      }
    ]
  },
  {
    path: '/journals',
    name: 'journal',
    component: Journal,
    meta: {
      requireAuth: true,
      title: 'OmniIoTh | Бортовой журнал'
    },
    children: [
      {
        path: 'multithing/:id',
        name: 'journalMultithingInProject',
        component: Journal,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Бортовой журнал'
        }
      },
      {
        path: 'project/:id',
        name: 'journalThingsInProject',
        component: Journal,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Бортовой журнал'
        }
      },
      {
        path: 'project/:id/project-item/:item',
        name: 'journalThingsInProjectItem',
        component: Journal,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Бортовой журнал'
        }
      },
      {
        path: `journal-:id`,
        name: 'journalItem',
        component: JournalItem,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Бортовой журнал'
        }
      },
      {
        path: 'journal-:id/create',
        name: 'JournalCreate',
        component: JournalCreate,
        meta: {
          requireAuth: true,
          title: 'OmniIoTh | Бортовой журнал'
        }
      },
    ]
  },
  // {
  //   path: '/project/:id/project-item/:item',
  //   name: 'projectItem',
  //   component: ProjectItem,
  //   meta: {
  //     requireAuth: true,
  //     title: 'OmniIoTh | Проект'
  //   }
  // }
];

const router = new VueRouter({
	mode: 'history',
	routes
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requireAuth)) {
    if (store.getters['auth/loggedIn']) {
      store.commit('sidebar/SET_SHOW_SIDEBAR', true);
      if(!!to.params && !!to.params.id){
        document.title = to.meta.title + to.params.id
      } else {
        document.title = to.meta.title;
      }
      next();
      return
    }
    store.commit('sidebar/SET_SHOW_SIDEBAR', false);
    document.title = to.meta.title;
    next('/login');
  } else {
    document.title = to.meta.title;
    next();
  }
});

export default router
